import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ITask } from 'src/app/modules/unit/interfaces/task.interface';
import { TaskService } from '../../services/task.service';
import { TaskCaseService } from '../../services/taskCase.service';

@Component({
  selector: 'app-generate-tasks',
  templateUrl: './generate-tasks.component.html',
  styleUrls: ['./generate-tasks.component.scss'],
})
export class GenerateTasksComponent implements OnInit {
  constructor(
    private readonly dialogRef: MatDialogRef<GenerateTasksComponent>,
    private readonly taskService: TaskService,
    private readonly taskCaseService: TaskCaseService,
    @Inject(MAT_DIALOG_DATA)
    private data: { case: string; task?: string; caseType?: string }
  ) {}

  tasks: ITask[] = [];

  taskSelected = [];

  addToSelected(task: ITask) {
    this.tasks = this.tasks.filter((tarea) => tarea._id !== task._id);
    this.taskSelected.push(task);
  }

  removeFromSelected(task: ITask) {
    this.taskSelected = this.taskSelected.filter(
      (tarea) => tarea._id !== task._id
    );
    this.tasks.push(task);
  }

  ngOnInit() {
    if (this.data.task) {
      this.taskService
        .getTaskToGenerate(this.data.task, this.data.case)
        .subscribe({
          next: (data) => {
            this.tasks = data;
          },
        });
    }

    if (this.data.caseType) {
      this.taskService
        .getTaskToGenerateByCaseType(this.data.caseType, this.data.case)
        .subscribe({
          next: (data) => {
            this.tasks = data;
          },
        });
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

  addTasks() {
    let ids = this.taskSelected.map((x) => x._id);
    this.taskCaseService.createTaskCases(this.data.case, ids).subscribe({
      next: (taskCases) => {
        taskCases.forEach((task) => {
          this.taskCaseService.taskCreated.next(task);
        });
        this.dialogRef.close();
      },
    });
  }
}
